import { render, staticRenderFns } from "./filterMedic.vue?vue&type=template&id=77cfc50a&scoped=true&"
import script from "./filterMedic.vue?vue&type=script&lang=js&"
export * from "./filterMedic.vue?vue&type=script&lang=js&"
import style0 from "./filterMedic.vue?vue&type=style&index=0&id=77cfc50a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cfc50a",
  null
  
)

export default component.exports